import type { ReactNode } from 'react';
import { Link } from '@dx-ui/global-ui-prism';

type MobileAccountUserLinkProps = {
  url: string;
  onClick: () => void;
  children: ReactNode;
  isNewWindow?: boolean;
};

export const MobileAccountUserLink = ({
  url,
  onClick,
  children,
  isNewWindow,
}: MobileAccountUserLinkProps) => {
  return (
    <Link
      colorTheme="inherit"
      anchorClassName="block border-surface px-6 py-2 focus:osc-nav-drawer-link-active hover:osc-nav-drawer-link-active"
      className="osc-nav-account-text text-surface"
      underline={false}
      url={url}
      onClick={onClick}
      isNewWindow={isNewWindow}
    >
      {children}
    </Link>
  );
};
